import { ApiService as api } from "../Services/APIService";
import Tick from '@pqina/flip';
import { TemplateService } from "../Services/TemplateService";
import { HeartService as heartService } from "../Services/HeartService";
import { UtilService as util } from "../Services/UtilService";

var liveCongregationId;
var liveTimeout;
var sermonDetailsUrl;
var seriesDetailUrl;
var liveHub;
var connection;
var currentSermonPlayerEl;

const liveTemplate = "LiveStream";

export class LiveStreamCountDown {
  
    static initializeLiveStreaming() {
        DEBUG && console.info('==> LiveStream::Init Live Stream');
        let self = this;
        DEBUG && console.log('Tick', Tick);

        // create a ticker on an element with options
        var element = document.getElementById('LiveStreamingCountdown');
        sermonDetailsUrl = element.getAttribute('data-sermonUrl');
        seriesDetailUrl = element.getAttribute('data-seriesUrl');
        liveCongregationId = element.getAttribute('data-congregation');
        liveHub = element.getAttribute('data-hub');

        self.tickClock = Tick.DOM.create(element, {
            value: ["00", ":", "00"],
            didInit: function (tick) {
                self.handleTickInit(tick);
            }
        });
    }

    static async handleTickInit(tick) {

        DEBUG && console.info('==> LiveStream::: handleTickInit');

            fetch(`${apiRoot}/api/sermon/GetNextLiveStreamingDate?congregationId=${liveCongregationId}`, {
                    headers: {
                        "Content-Type": "text/plain"
                    }
                })
            .then(response => response.text())
            .then(obj => {
                Tick.count.down(obj)
                    .onupdate = function (value) {
                        tick.value = value;
                    };

                // Update H3 with Date / Time
                var nextStreamElement = document.getElementById("LiveCountDownDate");
                var nextDate = new Date(obj);
                const options = { weekday: 'long' };
                const dayOfWeekName = nextDate.toLocaleDateString(undefined, options);
                DEBUG && console.info(nextDate);
                DEBUG && console.info(nextDate.getDay());

                var hours = nextDate.getHours();        // Get the hours (0-23)
                const minutes = nextDate.getMinutes(); 
                var ampm = "AM";
                if (hours > 11) {
                    ampm = "PM";
                }

                if (hours > 12) {
                    hours = hours - 12;
                }

                nextStreamElement.textContent = `${dayOfWeekName} ${hours}:${minutes.toString().padStart(2, '0')} ${ampm}`;

                // Show / Hide Stream Data
                this.checkStreamSwitchOver();
            })
            .catch(err => console.error(err));
    }


    static async checkStreamSwitchOver() {
        DEBUG && console.info('==> LiveStream:::Checking Stream Status');

        var data = await api.getData(`sermon/GetCampusLiveStreaming?congregationId=${liveCongregationId}&sermonDetailsUrl=${sermonDetailsUrl}&seriesDetailUrl=${seriesDetailUrl}`);

        DEBUG && console.info(data);

        if (data && data.Streaming && data.Streaming.RESI_Embed_ID) {

            //Stop the timeout check
            DEBUG && console.info('==> LiveStream:::Kill Timeout (Live)');
            clearTimeout(liveTimeout);

            var countdownElement = document.getElementById('LiveCountDownContainer');
            countdownElement.style.display = 'none';

            await this.ShowLiveStream(data);
        }
        else {
            // Restart the timer for another 30 seconds
            DEBUG && console.info('==> LiveStream:::CreateTimeout to check for live service');

            let that = this;

            liveTimeout = setTimeout(() => {
                that.checkStreamSwitchOver();
            }, 30000);

            var countdownElement = document.getElementById('LiveCountDownContainer');
            countdownElement.style.display = 'block';
        }
    }

    static async ShowLiveStream(data) {
        // Get Container
        const container = document.getElementById('LiveStreamingLive');

        let dataObj = {};
        dataObj.Sermon = data.Sermon;
        dataObj.apiRoot = apiRoot;       
        dataObj.Campus = util.getCampus();

        if (!dataObj.Campus) {
            dataObj.Campus = "melbourne";
        }

        console.log(dataObj);

        //Render Template
        var content = await TemplateService.GetRenderedTemplate(liveTemplate, dataObj);
        //Set Template Data
        container.innerHTML = content;

        // Show the whole block
        var liveElement = document.getElementById('LiveStreamingLive');
        liveElement.style.display = 'block';

        

        // Initialize the Player
        // Get Player Element
        currentSermonPlayerEl = container.querySelectorAll(`div[data-component="sermonPlayer"]`)[0];

        var videoplaylist =
        [{
            'title': `${data.Sermon.Title}`,
            'image': `${data.Sermon.Series.Series.Image_URL}`,
            'file': `${data.Streaming.HLS_Url}`
        }];

        jwplayer(currentSermonPlayerEl).setup({
            height: 'auto',
            width: '100%',
            nextUpDisplay: false,
            playlist: videoplaylist,
            sharing: null
        });

        jwplayer().on('ready', function (e) {
            DEBUG && console.info('==**> Player is Ready');            
            DEBUG && console.info('==> Player::Add Heart Button to JWPlayer Interface...');
            jwplayer().addButton("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAABWUlEQVR4nO3Wu0rEQBQG4FEbRVDwgvgcWnh5EW0E30B8AhttvTWyYOWqkMLKPmIxufz/rEF8AndL7V3BHRk2CxI2s1mTKcT94XSHfDmTExghRvm3ieN4g+QNgBaANskmgCul1Eq2Vym1CqD+s5fktVJqvTDoed4EyTOSul8B+AJwqLUeMwXgCEAnp7cD4MQ8cyBsQzNl+s6L9AI4HoSu5b192QKwaYNvXaApXM+FzXK4gkm+2ib+dDhx2wa/O5z4zXbUjw7hBxu87xDey4WjKJoH8OHi+zYajcVcOJ265mDaCyvam9osQoWoWdgFUSRKqd0Kj3mnENoLycsK0JoYNlLKKQBBCVT6vj85NGxCcpbk0y/gZynlnCgTksskX4ZBgyBYElUk6v7fKIBGpSfNJkmSaQB3FvQ+DMMZ4SK6e9U56HNZONVajwvXAbCdXuxacRxvOQdH+ZP5Bmb6U7alkw1MAAAAAElFTkSuQmCC"
                , "Shout Amen"
                , function () {

                    // Send the Heart on WebSocket
                    heartService.sendHeart(connection);

                }
                , 'amenButton'
                , "amenBtn"
            );

            DEBUG && console.info('==**> Player is Ready');       
        });

        jwplayer().once('play', function (e) {
            DEBUG && console.log('==> Player::Live Stream Started Playing');
            
            util.addMediaAnalytics('SermonPlay', 'live', `${data.Streaming.Congregation_ID}`, false);            
        });

        this.setupLiveSignalR(liveHub);

        await this.SetupSermonNotes(data.Sermon.Sermon_ID, 'sermonNotes', 'containerSermonNotes', 'btnSermonNotes');        
    }

    static async SetupSermonNotes(sermonId, sermonNotesElement, sermonNotesContainerElement, sermonNotesButtonElement) {
        const elementButton = document.getElementById(sermonNotesButtonElement);
        const elementNotesContainer = document.getElementById(sermonNotesContainerElement);
        const elementNotes = document.getElementById(sermonNotesElement);

        var data = await api.getData(`Sermon/GetSermonNotes/${sermonId}`);

        if (data) {
            elementNotes.innerHTML = data.Sermon_Notes;
            elementButton.addEventListener('click', (evt) => {
                if (elementNotesContainer.style.display == 'none') {
                    elementNotesContainer.style.display = 'block';
                }
                else {
                    elementNotesContainer.style.display = 'none';
                }
            });

            elementButton.style.display = 'block';
        }
    }


    /// =======================================================================================
    /// SignalR Methods
    /// =======================================================================================

    static setupLiveSignalR(liveHub) {
        if (liveHub) {
            connection = new signalR.HubConnectionBuilder().withUrl(`/${liveHub.replace('/', '')}`).build();

            connection.on("LiveCount", function (liveCount) {
                DEBUG && console.log(`==>SignalR::Updating LiveCount: ${liveCount}`);
                var liveCountElement = document.getElementById("liveCount");
                liveCountElement.innerHTML = `<label class="liveCount">${liveCount} watching</label>`;
            });

            connection.on("HeartCount", function () {
                DEBUG && console.info('==>SignalR::Trigger Heart in Video UI');
                heartService.addHeart();
            });

            connection.on("ReceiveMessage", function (user, message) {
                console.info(`'==>SignalR::${user} says ${message}`);
            });

            connection.start();
        }
    }
}